import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './app/store';
import {AppWithRedux} from './app/AppWithRedux';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';


export interface ApiUrlWindow extends Window {
  apiurl: string
}

declare let window: ApiUrlWindow

let urlElements = window.location.href.split('/')
let url = (urlElements[2])
sessionStorage.setItem('url', url)
let apiurl

if (url === "localhost:3000") {
  //window.apiurl = "bugs-api.webquake.com"
  window.apiurl = "https://localhost:4256/api"
  apiurl = window.apiurl
  sessionStorage.setItem('apiurl', window.apiurl)
} else {
  // axios.get("https://" + url + "/ApiEndpoint").then(res => {
  //   apiurl = res.data.apiEndpoint
  //   console.log('apiurl ', apiurl)
  //   window.apiurl = apiurl
  //   sessionStorage.setItem('apiurl', window.apiurl)
  // })
  apiurl = "bugs-api.webquake.com/api"
  window.apiurl = apiurl
  sessionStorage.setItem('apiurl', window.apiurl)
  }

  console.log('url ', url)
  console.log('apiurl ', apiurl)

ReactDOM.render(
  <Provider store = {store}>
    <BrowserRouter>
     <AppWithRedux />
     </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
